import { gql } from '@apollo/client';

export default gql`
  query notifications($page: Int, $unreadOnly: Boolean, $kind: [String!]) {
    notifications(page: $page, unreadOnly: $unreadOnly, kind: $kind) {
      perPage
      hasNextPage
      currentPage
      notificationsTotal
      notificationsTotalPages
      unreadTotal
      notifications {
        id
        kind
        title
        body
        payload
        readAt
        seenAt
        createdAt
        actor {
          id
          name
          surname
          email
        }
        notifiable {
          ... on Space {
            id
            name
          }
          ... on Inspection {
            id
            name
          }
        }
        space {
          id
        }
      }
    }
  }
`;
